<script setup lang="ts">
// A small playing card showing a single suit glyph — ported from logos.jsx.
import { computed } from 'vue'
import { BK } from '../tokens'

const props = withDefaults(
  defineProps<{ w?: number; suit?: string; color?: string; tilt?: number }>(),
  { w: 74, suit: '♠', color: BK.pine, tilt: 0 },
)

const cardStyle = computed(() => ({
  width: `${props.w}px`,
  height: `${props.w * 1.4}px`,
  borderRadius: `${props.w * 0.1}px`,
  background: '#f4eddb',
  border: '2px solid rgba(43,37,25,.18)',
  boxShadow: '0 2px 0 rgba(43,37,25,.14), 0 8px 16px rgba(43,37,25,.18)',
  transform: `rotate(${props.tilt}deg)`,
}))
const suitStyle = computed(() => ({
  fontSize: `${props.w * 0.5}px`,
  color: props.color,
  fontFamily: '"Zilla Slab", serif',
}))
</script>

<template>
  <div class="suit-card" :style="cardStyle">
    <span class="suit-card__glyph" :style="suitStyle">{{ suit }}</span>
  </div>
</template>

<style scoped>
.suit-card {
  position: relative;
  flex-shrink: 0;
}
.suit-card__glyph {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}
</style>
